import { ERefundMotiveId } from 'v2/interfaces/requestManagement/refund';
import * as Yup from 'yup';

const OTHER_CONTRACT_CANCEL_REASON = 1;

const RefundPartnerRequestSchema = Yup.object().shape({
  motive: Yup.string().required('Selecione um motivo'),
  detail: Yup.string().when('motive', {
    is: (v: string) => v === ERefundMotiveId.OTHER_REASON,
    then: Yup.string().required('Insira os detalhes do reembolso').min(5),
  }),
  cancelContractMotive: Yup.number().when(['contractId', 'cancelContract'], {
    is: (contractId: number, cancelContract: boolean) => !!contractId && cancelContract,
    then: Yup.number().required('Selecione um motivo'),
  }),
  cancelContractDetail: Yup.string().when('cancelContractMotive', {
    is: (v: number) => v === OTHER_CONTRACT_CANCEL_REASON,
    then: Yup.string().required('Insira os detalhes do cancelamento do contrato').min(5),
  }),
});

const RefundBuyerRequestSchema = Yup.object().shape({
  motive: Yup.string().required('Selecione um motivo'),
  detail: Yup.string().when('motive', {
    is: (v: string) => v === ERefundMotiveId.OTHER_REASON,
    then: Yup.string().required('Insira os detalhes do reembolso').min(5),
  }),
});

export { RefundPartnerRequestSchema, RefundBuyerRequestSchema };
